export const DEFAULT_SUGGESTIONS = [
  'Show cancelled shipments',
  "Today's shipments",
  'Pending deliveries',
  'International shipments',
  'FedEx shipments',
  'Shipments from Delhi',
  'Shipments to Mumbai',
  'High priority shipments',
  'Shipments above 50kg',
];

export const ROTATING_THINKING_MESSAGES = [
  'Analyzing shipment history...',
  'Understanding your request...',
  'Searching shipment records...',
  'Finding matching shipments...',
  'Preparing results...',
  'Generating summary...',
];

export const SHIFT_SHORTCUT_KEY = '/';
